<template>
    <div>
        <div class="entry-info_item mb-1">
            <span class="label small-caps">Internal Notes:</span>
            <div class="value internal-text-value" v-if="!WysiwygOpen"><span v-html="originalInternalNote"></span> <a href="#" @click.prevent="WysiwygOpen = !WysiwygOpen" v-text="editOrAdd"></a></div>
        </div>
        <div class="editor" v-if="WysiwygOpen">
            <jodit-vue v-model="internalNote" :buttons="buttons" class="form-control" name="content"></jodit-vue>
            <div class="edit-buttons mt-2">
                <button class="btn save" @click="saveInternalNote"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-default btn-grey cancel" @click="closeInternalNote"><i class="fa fa-ban"></i> Cancel</button>
            </div>
            <a href=""></a>
        </div>
    </div>
</template>

<script>
    import 'jodit/build/jodit.min.css'
    import { JoditVue } from 'jodit-vue'

    export default {
        components: { JoditVue },
        props: ['actionurl', 'internal_note_loaded'],
        data() {
            return {
                buttons: ['bold', 'underline', 'italic', 'eraser', 'ul', 'ol'],
                internalNote: '',
                editOrAdd: 'Add',
                WysiwygOpen: false,
                originalInternalNote: '',
            }
        },
        created: function() {
            this.originalInternalNote = this.internal_note_loaded;
            this.internalNote = this.internal_note_loaded;
            if(this.originalInternalNote.length > 0) {
                this.editOrAdd = 'Edit';
            }
        },
        watch: {
            WysiwygOpen: function (val) {
                if(val) {
                    this.editOrAdd = 'Close';
                } else {
                    if(this.originalInternalNote.length > 0) {
                        this.editOrAdd = 'Edit';
                    } else {
                        this.editOrAdd = 'Add';
                    }
                }
            },
        },
        methods: {
            saveInternalNote: function() {
                let that = this;
                window.axios({
                    method: 'POST',
                    url: this.actionurl,
                    data: {
                        internal_note: that.internalNote
                    }
                }).then(function(response) {
                    // console.log('data saved111');
                    that.originalInternalNote = that.internalNote;
                    that.WysiwygOpen = false;
                }).catch(function (err) {
                  let errorMessage = err.response.status + ' status error';
                  app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
                });
            },
            closeInternalNote: function() {
                this.WysiwygOpen = false;
                this.internalNote = this.originalInternalNote;
            }
        }
    }
</script>
